
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/500",
      function () {
        return require("private-next-pages/500/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/500"])
      });
    }
  